import React, { forwardRef } from "react";

import { ShimmerProps } from "./Shimmer.types";
import { StyledShimmer } from "./Shimmer.styles";

const Shimmer = forwardRef<HTMLDivElement, ShimmerProps>((props, ref) => {
    return <StyledShimmer ref={ref} {...props} />;
});

export default Shimmer;
